import React from 'react';
import GenericSectionDashboard from '../GenericSectionDashboard';

const ECOMDashboard = () => {
  return (
    <GenericSectionDashboard
      sectionName="ECOM Section"
      sectionId="ecom"
      sectionKey="ECOM"
      description="E-commerce Order Fulfillment"
      backRoute="/"
    />
  );
};

export default ECOMDashboard;
